export default __webpack_public_path__ + "static/media/DashedPurple.dac9fb22.svg";